import {
  contenuTemoignageMock,
  pushTemoignagesMock,
  sliderGalerieImagesMock,
  titreDescriptionMock,
} from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreDescriptionMock(true, false), sliderGalerieImagesMock, contenuTemoignageMock, pushTemoignagesMock];

export const temoignagesClientsDetailsMock: SlugPage = {
  ...pageBase({
    title: 'Temoignages client détails',
    type: 'temoignages-clients-details',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
